"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
const useBuildInfo = () => {
  const [buildInfo, setBuildInfo] = (0, _react.useState)(null);
  const refetch = async () => {
    try {
      const url = process.env.GATSBY_PREVIEW_API_URL || ``;
      const res = await fetch(url, {
        mode: `cors`,
        headers: new Headers({
          "Content-Type": `application/json`,
          /*
           * NOTE: Current auth token used is the same auth token that preview exposes
           * Currently this token is only used for read-only purposes but it's good to note for the future if this changes
           */
          Authorization: process.env.GATSBY_PREVIEW_AUTH_TOKEN || ``,
          "x-runner-type": `PREVIEW`
        })
      });
      const data = await res.json();
      setBuildInfo(data);
    } catch (e) {
      setBuildInfo(null);
      console.log(e, e.message);
    }
  };
  (0, _react.useEffect)(() => {
    refetch();
  }, []);
  return {
    buildInfo,
    refetch
  };
};
var _default = useBuildInfo;
exports.default = _default;